export const CrmLogos: Partial<Record<string, string>> = {
  aspire: '/integrations/aspire-logo.svg',
  dynamics: '/integrations/dynamics-logo.svg',
  hubspot: '/integrations/hubspot-logo.svg',
  pipedrive: '/integrations/pipedrive-logo.svg',
  salesforce: '/integrations/IcoSalesforce.png',
  zoho: '/integrations/zoho-logo.svg',
};
